import PageContainer from "components/PageContainer/PageContainer";
import React, { useEffect, useState } from "react";
import { fetchDataDashboard } from "./model";
import { useTranslation } from "react-i18next";
import s from "./AnalyticsDataDashboard.module.scss";
import InnerTabList from "components/InnerTabList/InnerTabList";
import ErrorOverlay from "components/PageContainer/ErrorOverlay";
import { useAuth } from "utils/useAuth/useAuth";

/**
 * @param {Object} props
 * @param {"weeklySales"|"summary"|"internalExternal"|"salesperson"} props.type
 * @returns
 */

const LOCALE_KEY = "page.analytics.dataDashboard.";

const AnalyticsDataDashboard = ({ type }) => {
  const { t } = useTranslation();
  const { logout } = useAuth();

  const [loading, setLoading] = useState(true);
  const [unauthorized, setUnauthorized] = useState(false);
  const [error, setError] = useState();

  const [selectTab, setSelectTab] = useState();
  const [url, setUrl] = useState();
  const [tabList, setTabList] = useState();

  const isValidLink = (link) => {
    try {
      new URL(link);
      return true;
    } catch (e) {
      return false;
    }
  };

  const changeSelectedTab = (event, innerTabName) => {
    setSelectTab(innerTabName);
  };

  const fetchData = async () => {
    setLoading(true);

    const apiResponse = await fetchDataDashboard(type);

    if (!apiResponse) {
      setError("networkError");
      setLoading(false);
      return;
    }

    switch (apiResponse.status) {
      case 401: {
        console.log("You have no authorization to view the page");
        return logout("TOKEN_EXPIRED");
      }
      case 403: {
        setUnauthorized(true);
        setLoading(false);
        return;
      }
      default: {
        setError(true);
        setLoading(false);
        return;
      }
      case 200:
        break;
    }

    const responseBody = apiResponse.data;
    switch (responseBody.responseCode) {
      case "0000": {
        if (typeof responseBody.data === "string") {
          setUrl(responseBody.data);
        } else {
          const tabList = Object.entries(responseBody.data).map(
            ([key, value]) => ({
              key: key,
              label: key.charAt(0).toUpperCase() + key.slice(1),
              value: key,
              link: value,
            }),
          );
          console.log(tabList);
          setTabList(tabList);
          setSelectTab(Object.keys(responseBody.data)[0]);
        }
        break;
      }
      case "1100":
      case "1200": {
        setUnauthorized(true);
        break;
      }
      case "1000": {
        setError(t(LOCALE_KEY + "error.1000"));
        break;
      }
      default: {
        setError(true);
      }
    }

    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const renderPage = () => {
    if (url)
      return (
        <iframe
          allowFullScreen={true}
          src={url}
          style={{
            height: "calc(100% - 5px)",
            width: "100%",
            border: "none",
          }}
        />
      );
    if (tabList)
      return (
        <>
          <div className={s["inner-tab-container"]}>
            <InnerTabList
              scrollable
              selectedTab={selectTab}
              handleChangeTab={changeSelectedTab}
              tabList={tabList}
            />
          </div>
          <div style={{ height: "calc(100% - 48px - 5px)" }}>
            {isValidLink(tabList.find((tab) => selectTab === tab.key).link) ? (
              <iframe
                allowFullScreen={true}
                src={tabList.find((tab) => selectTab === tab.key).link}
                style={{
                  height: "calc(100% - 5px)",
                  width: "100%",
                  border: "none",
                }}
              />
            ) : (
              <ErrorOverlay
                errorMessage={t(LOCALE_KEY + "error.invalidLink")}
              />
            )}
          </div>
        </>
      );
  };

  return (
    <PageContainer
      noPadding
      loading={loading}
      unauthorized={unauthorized}
      errorMessage={error}
    >
      {renderPage()}
    </PageContainer>
  );
};

export default AnalyticsDataDashboard;
